module.exports = __webpack_public_path__ + "img/one_9.01a106d8.png";